import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/h1K7wchd8DrbaDPHhF3buh/ChatGPT-Image-22-jun-2026_-22_30_15.webp';
export function Hero() {
  return <section className="pt-8 pb-6 px-4 sm:px-6 bg-brand-paper text-center border-b-4 border-brand-navy" data-id="element-92">
      <div className="relative z-10" data-id="element-93">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-teal/10 border border-brand-teal/30 text-brand-teal font-bold text-xs sm:text-sm mb-4 shadow-sm" data-id="element-94">
          <span data-id="element-95">🏃</span>
          <span className="tracking-wide uppercase" data-id="element-96">
            VALIDATED COACHING SYSTEM
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black text-brand-navy leading-tight mb-4 uppercase" data-id="element-97">
          The Complete Planning System <br className="hidden sm:block" data-id="element-98" />
          <span className="text-brand-orange" data-id="element-99">for Running Coaches</span>
        </h1>

        <p className="text-base sm:text-lg text-brand-ink/80 font-medium leading-snug mb-6 max-w-2xl mx-auto" data-id="element-100">
          Save hours of planning, deliver better training sessions, and coach
          with confidence — without building every workout from scratch.
        </p>

        <a href="#pricing" className="block cursor-pointer mb-6" data-id="element-101">
          <img src={PRODUCT_IMG} alt="Running Coach Ready Box Set" className="w-full max-w-md mx-auto object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-102" />
        </a>

        <div className="mb-4 max-w-md mx-auto" data-id="element-103">
          <CTAButton data-id="element-104">🚀 YES, I WANT MY SYSTEM NOW</CTAButton>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs sm:text-sm text-brand-navy font-bold" data-id="element-105">
          <div className="flex items-center gap-1.5" data-id="element-106">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-107" />
            <span data-id="element-108">4.9/5 — Verified Professional Reviews</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-109">
            <Shield className="w-4 h-4 text-brand-green" data-id="element-110" />
            <span data-id="element-111">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}